/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-nested-ternary */

import TextField from '@brands/Components/Inputs/MuiTextField/TextField';
import MUISelectInput from '@brands/Components/Inputs/MuiSelectInput/MUISelectInput';
import MultiSelectInputMUI from '@brands/Components/Inputs/MuiMultiSelectInput/MultiSelectInputMUI';
import PhoneInput from '@brands/Components/Inputs/MuiTelInput/MuiTelInput';
import AddressSection from '@brands/Dashboard/Dashboard/SuperAdmin/Components/AddressSection/AddressSection';
import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import { CaseType } from '@brands/services/cases/types/ICase';
import { Pricings } from '@brands/services/identity/getPricings';
import { getUserById } from '@brands/services/identity/getUserById';
import { updateUserClientTag } from '@brands/services/identity/updateUserClientTag';
import {
  getClientDivisionOptions,
  scopeDivisionGroupsToClientAdmin,
} from '@brands/services/identity/clientDivisionOptions';
import { useDivisionScopeActor } from '@brands/hooks/useDivisionScopeActor';
import { updateVerifiedEmail } from '@brands/services/identity/updateUserEmail';
import { selectAuth } from '@brands/store/selectors/auth';
import { selectOrganization } from '@brands/store/selectors/organization';
import { selectOrganizationPrices } from '@brands/store/selectors/organizationPrices';
import { selectPageState } from '@brands/store/selectors/pageState';
import { selectPatientForm } from '@brands/store/selectors/patientForm';
import { selectPatient } from '@brands/store/selectors/selectedPatient';
import { setUser } from '@brands/store/slices/authSlice';
import { setDependentId, setIsFromSelectPatient } from '@brands/store/slices/pageStateSlice';
import { setStaffIntakeInProgress } from '@brands/store/slices/staffCaseCreationSlice';
import { setExternalForms } from '@brands/store/slices/patientFormSlice';
import { setPatientMyProfile } from '@brands/store/slices/patientMyProfileSlice';
import { setSelectedPatientByAdmin } from '@brands/store/slices/selectedPatientSlice';
import { checkExternalFormAnswers } from '@brands/Utils/checkExternalForms';
import { isFree, needsPayment } from '@brands/Utils/needsPayment';
import {
  getStaffReviewProfileBasePath,
  isStaffCaseCreationRole,
  isUnifiedStaffCaseIntakeRole,
} from '@brands/Utils/reviewProfileBasePath';
import {
  clientTagSelectionNeedsSave,
  getUserClientTagRefs,
  toClientTagOptions,
  toLockedSelectOptions,
} from '@brands/Utils/userClientTags';
import { UnifiedProfileSubmit } from '@brands/Utils/types';
import { validateAddress, ValidationModalInterface } from '@brands/Utils/validateAddress';
import { yupResolver } from '@hookform/resolvers/yup';

import { E164Number, parsePhoneNumber } from 'libphonenumber-js';
import { isEqual } from 'lodash';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useForm, UseFormGetValues } from 'react-hook-form';
import { MdKeyboardArrowLeft } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { MultiValue } from 'react-select';
import { toast } from 'react-toastify';
import { Box, Divider, Button as MuiButton, Typography } from '@mui/material';

import Button from '../../../../../Components/Button/Button';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/useReduxHook';
import { RegisterMediaPayload } from '../../../../../services/communication/registersConversationMedia';
import { confirmAvatarMedia } from '../../../../../services/identity/confirmAvatarMedia';
import { createBasicInformation } from '../../../../../services/identity/createBasicInformation';
import { deleteAvatar } from '../../../../../services/identity/deleteAvatar';
import { registerAvatarMedia } from '../../../../../services/identity/registerAvatarMedia';
import { saveBasicInformation } from '../../../../../services/identity/saveBasicInformation';
import {
  Address,
  BasicInfo,
  ClientTag,
  Marker,
  UserProfile,
  UserRoleName,
} from '../../../../../services/identity/types/UserProfile';
import { UpdateMe, updateMe } from '../../../../../services/identity/updateMe';
import { dateAutoSlashes } from '../../../../../Utils/checkAndSetDate';
import { displayErrorDetails } from '../../../../../Utils/displayError';
import { genderIdentity, genderOptions, pronounsOptions } from '../../../../../Utils/selectButtonOptions';
import { Option, OptionLanguage } from '../../../../../Utils/selectOptions';
import { MyProfileSubmit } from '../../utils/types';
import { areArraysEqual, updateData } from '../../utils/utilsFunctions';
import { profileValidationSchema } from '../../utils/validationSchema';
import ProfileImage from './ProfileImage/ProfileImage';
import styles from './styles.module.scss';
import addNewUserStyles from '../../../../Dashboard/Collector/AddNewUser/addNewUser.module.scss';

type EditProfileProps = {
  setImage: React.Dispatch<React.SetStateAction<string | undefined>>;
  image: string;
  myProfileForm: MyProfileSubmit;
  setMyProfileForm: React.Dispatch<React.SetStateAction<MyProfileSubmit>>;
  setIsEditProfile: React.Dispatch<React.SetStateAction<boolean>>;
  setSelection: React.Dispatch<React.SetStateAction<[number | null, number | null] | null>>;
  setCurrentAvatarURL: React.Dispatch<React.SetStateAction<string>>;
  currentAvatarURL: string;
  thisUser: UserProfile | null;
  setThisUser: React.Dispatch<React.SetStateAction<UserProfile>>;
  avatarAction: string;
  setAvatarAction: React.Dispatch<React.SetStateAction<string>>;
  reviewProfile: boolean | undefined;
  id: string | undefined;
  languageOptions: OptionLanguage[];
  clientTagOptions: Option[];
  allClientTags: ClientTag[];
  validationResponseId: string;
  setValidationResponseId: React.Dispatch<React.SetStateAction<string>>;
  onSaveSuccess?: () => void;
  externalAvatarPayload?: RegisterMediaPayload | null;
  externalAvatarFile?: File | null;
  onExternalAvatarSaved?: () => void;
  formRef?: React.RefObject<HTMLFormElement>;
  setIsDirty?: (dirty: boolean) => void;
};

const EditProfile = ({
  setImage,
  image,
  myProfileForm,
  setMyProfileForm,
  setIsEditProfile,
  setSelection,
  setCurrentAvatarURL,
  currentAvatarURL,
  thisUser,
  setThisUser,
  avatarAction,
  setAvatarAction,
  reviewProfile,
  id,
  languageOptions,
  clientTagOptions,
  allClientTags,
  validationResponseId,
  setValidationResponseId,
  onSaveSuccess,
  externalAvatarPayload,
  externalAvatarFile,
  onExternalAvatarSaved,
  formRef,
  setIsDirty,
}: EditProfileProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const { userInfo } = useAppSelector(selectAuth);
  const { values } = useAppSelector(selectPatientForm);
  const [fetchLoading, setFetchLoading] = useState(false);
  const { currentOrganization } = useAppSelector(selectOrganization);
  const organizationPrices = useAppSelector(selectOrganizationPrices);
  const { selectedPatient } = useAppSelector(selectPatient);
  const [showValidationAddressModal, setShowValidationAddressModal] = useState<ValidationModalInterface>({
    isOpen: false,
    title: '',
    whatYouEntered: '',
    recommended: false,
    recommendedAddress: '',
    onClose: undefined,
    onConfirmChange: undefined,
    onKeepCurrentAddress: undefined,
  });
  const [avatarPayload, setAvatarPayload] = useState<RegisterMediaPayload | null>(null);
  const [avatarFile, setAvatarFile] = useState<File | null>(null);
  const [isSavingProfile, setIsSavingProfile] = useState(false);
  const [key, setKey] = useState(0);
  const [guardianPatient, setGuardianPatient] = useState<UserProfile>();
  const { isFromSelectPatient, isEditInsuranceFlag } = useAppSelector(selectPageState);

  const roleNavigate = useRoleNavigate();
  const navigate = useNavigate();

  const phoneInputRef = useRef<HTMLInputElement>(null);
  const isHydratingFormRef = useRef(false);
  const hasUserEditedFormRef = useRef(false);

  const isAdminRole = useMemo(
    () =>
      userInfo.role.name === UserRoleName.Admin ||
      userInfo.role.name === UserRoleName.SuperAdmin ||
      userInfo.role.name === UserRoleName.OrganizationAdmin,
    [userInfo.role.name],
  );
  // A staff user completing a patient's profile to create a case for them: a
  // patient who was never invited to the platform only needs name and date of
  // birth, an invited one needs the full profile (address included).
  const isEssentialProfileIntake = Boolean(
    isStaffCaseCreationRole(userInfo.role.name) && isFromSelectPatient && thisUser?.status === 'Not Invited',
  );
  const addressUnavailableForAdmin = Boolean(
    isAdminRole && reviewProfile && !isFromSelectPatient && !thisUser?.address,
  );
  // True when the address is optional on this form and was left blank: there is
  // nothing to validate or save, and sending it would overwrite the stored one.
  const isOptionalAddressLeftBlank = (data: MyProfileSubmit): boolean =>
    (addressUnavailableForAdmin || isEssentialProfileIntake) &&
    ![data.address1, data.address2, data.city, data.state, data.zip_code].some((value) => value?.trim());

  let currentOrganizationPrices: any;

  if (isFromSelectPatient) {
    currentOrganizationPrices = organizationPrices?.currentOrganizationPrices?.find(
      (currentOrganizationPrise: Pricings) =>
        currentOrganizationPrise.case_types.includes(
          values.find((item) => item.form_question_id === 20)?.value.caseType as string,
        ),
    );
  }

  const {
    register,
    handleSubmit,
    setValue,
    setFocus,
    formState: { errors },
    getValues,
    watch,
  } = useForm<MyProfileSubmit>({
    mode: 'onChange',
    resolver: yupResolver(
      profileValidationSchema(
        reviewProfile,
        isAdminRole,
        isFromSelectPatient,
        addressUnavailableForAdmin,
        userInfo.role.name === UserRoleName.OrganizationAdmin,
        isEssentialProfileIntake,
      ),
    ),
  });

  const watchedClientTag = watch('clientTag');
  const watchedClientDivision = watch('clientDivision');
  const divisionScopeActor = useDivisionScopeActor();

  // A Client Admin never changes a patient's client tag, so the tag field is read-only for them and
  // the save sends the tag back as the server holds it; divisions under their own tag stay editable.
  const clientTagsLocked = Boolean(reviewProfile) && userInfo.role.name === UserRoleName.OrganizationAdmin;

  // A patient's single tag as one division group, so a Client Admin confined in it is offered only
  // their own divisions there and has to pick one (see `scopeDivisionGroupsToClientAdmin`).
  const divisionGroup = useMemo(() => {
    const options = getClientDivisionOptions(
      allClientTags,
      (watchedClientTag || []).map((tag) => tag.id),
      (watchedClientDivision || []).map((division) => ({
        id: String(division.id),
        value: Number(division.value),
        label: division.label,
      })),
    );
    const clientTagId = watchedClientTag?.[0]?.id;
    if (clientTagId == null) return { clientTagId: '', clientTagName: '', options };

    const [scoped] = scopeDivisionGroupsToClientAdmin(
      [{ clientTagId: String(clientTagId), clientTagName: watchedClientTag?.[0]?.label || '', options }],
      allClientTags,
      divisionScopeActor,
    );
    return scoped ?? { clientTagId: String(clientTagId), clientTagName: '', options: [] };
  }, [allClientTags, watchedClientTag, watchedClientDivision, divisionScopeActor]);

  const divisionOptions = useMemo(
    () => divisionGroup.options.map((option) => ({ id: option.id, value: String(option.value), label: option.label })),
    [divisionGroup],
  );

  // Every tag the patient holds, named from the patient's own record: the admin's catalog only
  // lists the tags they administer, and the locked field shows the rest too.
  const lockedClientTagOptions = useMemo(() => toLockedSelectOptions(getUserClientTagRefs(thisUser)), [thisUser]);

  // A patient holds one division, so one the Client Admin can't assign can't ride along beside a
  // new pick: moving the patient out of it is refused server-side. With nothing matching between
  // the patient and the admin, the division field stays hidden and the save leaves it alone.
  const patientDivisionOutOfScope =
    clientTagsLocked &&
    (watchedClientDivision || []).some(
      (division) => !divisionOptions.some((option) => String(option.id) === String(division.id)),
    );
  const divisionRequired = Boolean(divisionGroup.required) && !patientDivisionOutOfScope;

  /**
   * Whether the user has changed anything since the form was last hydrated or saved.
   * Comparing `myProfileForm` against live form values directly is unreliable here: the
   * parent re-maps `myProfileForm` from the freshly-saved user via `mapProfileToMyProfileSubmit`,
   * which doesn't always format fields identically to what's already in the form, so that
   * comparison can permanently disagree even with nothing left to save.
   */
  const [hasEditedSinceSave, setHasEditedSinceSave] = useState(false);

  useEffect(() => {
    setIsDirty?.(hasEditedSinceSave || avatarAction !== '');
  }, [hasEditedSinceSave, avatarAction, setIsDirty]);

  useEffect(() => {
    const subscription = watch(() => {
      if (!isHydratingFormRef.current) {
        hasUserEditedFormRef.current = true;
        setHasEditedSinceSave(true);
      }
    });

    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    hasUserEditedFormRef.current = false;
    setHasEditedSinceSave(false);
  }, [id]);
  const triggerProfileAvatar = React.useCallback(
    (avatarUrl: string) => {
      setValue('profile_img', avatarUrl, { shouldValidate: true });
      setMyProfileForm({
        ...getValues(),
        profile_img: avatarUrl,
      });
    },
    [getValues, setMyProfileForm, setValue],
  );
  const onCloseConfirmationModal = (): void => {
    setShowValidationAddressModal({
      isOpen: false,
      title: '',
      whatYouEntered: '',
      recommended: false,
      recommendedAddress: '',
      onClose: undefined,
      onConfirmChange: undefined,
      onKeepCurrentAddress: undefined,
    });
  };

  const checkExternalForms = async (selectedPatientId: number, updatedUser: UserProfile): Promise<string[]> => {
    const [checkProfile, checkMedicalHistory, checkMedicalConditionsFormAnswer, checkDentalHistoryFormAnswer] =
      await checkExternalFormAnswers(
        userInfo.role.name === UserRoleName.Admin ||
          userInfo.role.name === UserRoleName.SuperAdmin ||
          userInfo.role.name === UserRoleName.OrganizationAdmin
          ? guardianPatient ?? (updatedUser as UserProfile)
          : userInfo,
        updatedUser,
        userInfo.role.name,
      );

    const formsToSet: string[] = [];

    if (!checkProfile) {
      formsToSet.push('patient_profile');
    }
    if (!checkMedicalHistory) {
      formsToSet.push('patient_medical_history');
    }
    if (!checkMedicalConditionsFormAnswer) {
      formsToSet.push('patient_medical_conditions');
    }
    if (!checkDentalHistoryFormAnswer) {
      formsToSet.push('patient_dental_history');
    }

    dispatch(setExternalForms(formsToSet));
    return formsToSet;
  };

  useEffect(() => {
    const getGuardianPAtient = async (): Promise<void> => {
      if (
        userInfo.role.name === UserRoleName.Admin ||
        userInfo.role.name === UserRoleName.SuperAdmin ||
        userInfo.role.name === UserRoleName.OrganizationAdmin ||
        userInfo.role.name === UserRoleName.Collector ||
        userInfo.role.name === UserRoleName.CareAdvisor
      ) {
        if (selectedPatient.guardian_id != null) {
          const scopedRole =
            userInfo.role.name === UserRoleName.Collector || userInfo.role.name === UserRoleName.CareAdvisor
              ? userInfo.role.name
              : undefined;
          const guardianResponse = await getUserById(Number(selectedPatient.guardian_id), scopedRole);
          setGuardianPatient(guardianResponse);
        }
      }
    };
    if (isFromSelectPatient) {
      getGuardianPAtient();
    }
  }, [selectedPatient]);

  const fetchData = (selectedPatientId: number, updatedUser: UserProfile): Promise<string[]> => {
    setFetchLoading(true);
    return checkExternalForms(selectedPatientId, updatedUser);
  };

  const callSaveProfile = async (profileData: UnifiedProfileSubmit): Promise<void> => {
    setIsSavingProfile(true);
    let updatedUser;
    let afterReviewProfileUpdatedUser;
    try {
      // Email is optional on this form for non-admin roles (a patient may never
      // have been invited, and so never had one) — only PATCH it when the form
      // actually holds a new value. The backend 400s on an empty/missing email,
      // and since this call is awaited first, that throw skipped every other save
      // call below it (profile info, address, org, client tag...) entirely.
      if ((profileData as MyProfileSubmit).email && thisUser?.email !== (profileData as MyProfileSubmit).email) {
        updatedUser = await updateVerifiedEmail(thisUser?.id || 0, {
          email: (profileData as MyProfileSubmit).email,
        });
      }
      const pendingAvatarPayload = externalAvatarPayload ?? avatarPayload;
      const pendingAvatarFile = externalAvatarFile ?? avatarFile;

      if (pendingAvatarPayload && pendingAvatarFile && avatarAction === 'Upload') {
        const res = await registerAvatarMedia(pendingAvatarPayload);
        const mediaId = res.files[0].upload_id;
        const uploadResponse = await fetch(res.files[0].upload_url, {
          method: 'PUT',
          body: pendingAvatarFile,
          headers: { 'content-type': pendingAvatarFile.type },
        });
        if (!uploadResponse.ok) throw new Error(`Upload failed: ${uploadResponse.status}`);
        await confirmAvatarMedia(mediaId, Number(thisUser?.id));
        triggerProfileAvatar(res.files[0].upload_url);
        onExternalAvatarSaved?.();
      } else if (avatarAction === 'Remove') {
        await deleteAvatar(thisUser?.id || 0);
        triggerProfileAvatar('');
        onExternalAvatarSaved?.();
      }

      const dataWithUpdatedDOB = updateData(profileData);
      const { address1, address2, city, state, zip_code } = profileData;
      const userAddress: Address = { address1, address2, city, state, zip_code };
      const shouldPreserveUnavailableAddress = isOptionalAddressLeftBlank(profileData as MyProfileSubmit);
      const enteredPhoneNumber = (profileData as MyProfileSubmit).phone_number;
      updatedUser = await updateMe(
        {
          ...(profileData as UpdateMe),
          // The phone is optional for a never-invited patient; parsePhoneNumber
          // throws on an empty string.
          phone_number: enteredPhoneNumber?.trim()
            ? (parsePhoneNumber(enteredPhoneNumber, 'US')?.format('E.164') as string)
            : '',
          // Admin profile responses may omit an existing patient address. In
          // that case, leave it out of the PATCH so saving an unrelated field
          // (for example a client tag) cannot erase the stored address.
          address: shouldPreserveUnavailableAddress ? undefined : userAddress,
        },
        thisUser?.id || 0,
        userInfo.role.name,
      );

      if (thisUser && thisUser.basic_info !== null) {
        updatedUser = await saveBasicInformation(
          {
            ...(dataWithUpdatedDOB as BasicInfo),
            languages: ((profileData as MyProfileSubmit).language || []).map((language) => language.id.toString()),
          },
          thisUser?.id || 0,
          userInfo.role.name,
        );
      } else {
        updatedUser = await createBasicInformation(
          {
            ...(dataWithUpdatedDOB as BasicInfo),
            languages: ((profileData as MyProfileSubmit).language || []).map((language) => language.id.toString()),
          },
          thisUser?.id || 0,
          userInfo.role.name,
        );
      }

      if (thisUser && reviewProfile) {
        const promises: Promise<UserProfile>[] = [];

        // Organization and its division/practice aren't editable here (everyone belongs to
        // Dentistry One), so the save never rewrites them and the patient keeps what's on record.

        // Compare against the user's client tags, not `markers`: a marker's `id` is the
        // marker record's own id, while the form option's `id` is the client tag id — so
        // an id-based comparison against markers never matches. A markers-only user always
        // writes, since a code match there does not prove the backend stamped `clients`.
        const clientTagChanged = clientTagSelectionNeedsSave(thisUser, getValues('clientTag') || []);
        const clientDivisionChanged = !areArraysEqual(
          (thisUser.divisions || []) as unknown as Marker[],
          getValues('clientDivision') || [],
        );

        if (clientTagsLocked) {
          // The tags go back exactly as the patient holds them (not the catalog-filtered form value):
          // the server lets an unchanged set through and scopes only the division this save changes.
          const heldClientTagIds = (thisUser.clients || []).map((client) => Number(client.id));
          const clientTagIds = heldClientTagIds.length
            ? heldClientTagIds
            : (getValues('clientTag') || []).map((tag) => Number(tag.id));
          const nextDivisionIds = (getValues('clientDivision') || []).map((division) => Number(division.id));
          const existingDivisionIds = (thisUser.divisions || []).map((division) => Number(division.id));
          const isDentistryOnePatient = getValues('organizations')?.some((org) => org.id === 'dentistry-one');
          if (
            isDentistryOnePatient &&
            clientTagIds.length > 0 &&
            !patientDivisionOutOfScope &&
            !isEqual([...nextDivisionIds].sort(), [...existingDivisionIds].sort())
          ) {
            promises.push(
              updateUserClientTag(
                thisUser.id,
                { client_ids: clientTagIds, client_division_ids: nextDivisionIds.slice(0, 1) },
                userInfo.role.name,
              ),
            );
          }
        } else if (getValues('clientTag') && (clientTagChanged || clientDivisionChanged)) {
          const updatedClientTags = getValues('clientTag');
          const clientTagIdList: number[] = [];

          if (updatedClientTags) {
            for (const updatedOrganization of updatedClientTags) {
              clientTagIdList.push(updatedOrganization.id as number);
            }
          }

          const isDentistryOnePatient = getValues('organizations')?.some((org) => org.id === 'dentistry-one');

          const updatedClientDivisions = getValues('clientDivision');
          const clientDivisionIdList: number[] = [];
          if (updatedClientDivisions) {
            for (const updatedDivision of updatedClientDivisions) {
              clientDivisionIdList.push(updatedDivision.id as number);
            }
          }

          if (clientTagIdList.length > 0 && isDentistryOnePatient) {
            promises.push(
              updateUserClientTag(
                thisUser.id,
                {
                  client_ids: clientTagIdList.slice(0, 1),
                  client_division_ids: clientDivisionIdList.slice(0, 1),
                },
                userInfo.role.name,
              ),
            );
          } else {
            promises.push(
              updateUserClientTag(
                thisUser.id,
                {
                  client_ids: [],
                  client_division_ids: [],
                },
                userInfo.role.name,
              ),
            );
          }
        }

        afterReviewProfileUpdatedUser = await Promise.all(promises);
      }

      const formClientTag = getValues('clientTag');
      // A client-tag option carries the tag's id in `id` and its code in `value`, so a
      // selection maps straight onto the user's `clients` entries.
      const clientsFromForm: ClientTag[] =
        Array.isArray(formClientTag) && formClientTag.length > 0
          ? formClientTag.map((opt) => ({
              id: Number(opt.id) || 0,
              name: opt.label || allClientTags.find((c) => c.id === Number(opt.id))?.name || '',
              code: opt.value,
            }))
          : [];

      const lastResponseUser = afterReviewProfileUpdatedUser?.[afterReviewProfileUpdatedUser.length - 1];
      const clientsAreFormAuthoritative = Boolean(afterReviewProfileUpdatedUser) && Array.isArray(formClientTag);
      const resolvedClients: ClientTag[] = clientsAreFormAuthoritative
        ? clientsFromForm
        : (toClientTagOptions(getUserClientTagRefs(lastResponseUser), allClientTags).map((option) => ({
            id: Number(option.id) || 0,
            name: option.label,
            code: option.value,
          })) as ClientTag[]);

      // `getUserClientTagRefs` falls back to `markers` whenever `clients` is empty, so a
      // stale marker spread in from the general save response would keep resolving a tag
      // the user just removed. Clear it whenever the form is the source of truth here.
      const resolvedMarkers: Marker[] = clientsAreFormAuthoritative
        ? []
        : lastResponseUser?.markers ?? (updatedUser as UserProfile | undefined)?.markers ?? [];

      const formClientDivision = getValues('clientDivision');
      const divisionsFromForm: UserProfile['divisions'] =
        Array.isArray(formClientDivision) && formClientDivision.length > 0
          ? formClientDivision.map((opt) => ({ id: Number(opt.id), name: opt.label }))
          : [];
      const lastResponseDivisions = lastResponseUser?.divisions;
      const resolvedDivisions: UserProfile['divisions'] = clientsAreFormAuthoritative
        ? divisionsFromForm
        : lastResponseDivisions ?? thisUser?.divisions ?? [];

      setThisUser({
        ...updatedUser,
        // This save never touches organization membership or its division/practice, so keep the
        // values on record in case the basic-info response leaves them out.
        organizations: thisUser?.organizations ?? updatedUser.organizations,
        patient_profile: {
          ...updatedUser.patient_profile,
          ...(reviewProfile && {
            divisions: updatedUser.patient_profile?.divisions ?? thisUser?.patient_profile?.divisions ?? [],
            practices: updatedUser.patient_profile?.practices ?? thisUser?.patient_profile?.practices ?? [],
          }),
        },
        clients: resolvedClients,
        markers: resolvedMarkers,
        divisions: resolvedDivisions,
      });

      const clientTagForForm = toClientTagOptions(
        getUserClientTagRefs({ clients: resolvedClients }),
        allClientTags,
      ) as Option[];

      setMyProfileForm({
        ...getValues(),
        organizations: getValues('organizations') || [],
        clientTag: clientTagForForm,
      });
      // Allow the hydration effect to re-sync the form once the parent's post-save
      // refetch lands, and clear the dirty flag so the unsaved-changes prompt
      // doesn't reappear for a save that already succeeded.
      hasUserEditedFormRef.current = false;
      setHasEditedSinceSave(false);
      // `setIsEditProfile(false)` a few lines down unmounts this component in the
      // same render (same as `onCancelEditProfile` above), so the effect that
      // normally propagates `hasEditedSinceSave` to the parent's dirty state never
      // gets to run with the reset value — the parent was left permanently believing
      // the tab was still dirty, blocking every subsequent navigation attempt with
      // the "unsaved changes" prompt even though the save had already succeeded.
      // Call `setIsDirty` directly so the parent is correct the instant this unmounts.
      setIsDirty?.(false);

      if (!reviewProfile) {
        dispatch(
          setPatientMyProfile({
            ...(profileData as MyProfileSubmit),
            isCompleted: true,
            patientId: thisUser?.id || 0,
            organizations: (profileData as MyProfileSubmit).organizations || [],
          }),
        );
        dispatch(setUser({ userInfo: updatedUser }));
      }
      if (
        isFromSelectPatient ||
        (thisUser?.role.name === UserRoleName.Patient && updatedUser.role.name === UserRoleName.Patient)
      ) {
        dispatch(setSelectedPatientByAdmin({ selectedPatient: updatedUser }));
      }
      setIsEditProfile(false);
      onSaveSuccess?.();
      if (!onSaveSuccess && isAdminRole && reviewProfile) toast.success('Your changes have been saved');

      // Intentionally inside `try`, after every awaited save call above has
      // resolved without throwing: this continues the staff intake flow into the
      // next step, so it must never run when a save actually failed. It used to
      // live in `finally`, which runs unconditionally on both success AND after
      // `catch` handles an error — so a failed save (e.g. the basic_info PATCH
      // 500ing) still showed the error toast *and* barreled ahead into the next
      // intake page as if nothing had gone wrong.
      if (isFromSelectPatient) {
        fetchData(thisUser?.id || 0, updatedUser as UserProfile);
        dispatch(setIsFromSelectPatient(false));
        dispatch(setDependentId(null));

        if (isUnifiedStaffCaseIntakeRole(userInfo.role.name)) {
          if (
            (values.find((item) => item.form_question_id === 20)?.value.caseType as string) ===
              'video_call_scheduled' ||
            (values.find((item) => item.form_question_id === 20)?.value.caseType as string) ===
              CaseType.phone_call_scheduled ||
            (values.find((item) => item.form_question_id === 20)?.value.caseType as string) ===
              CaseType.oral_health_coaching ||
            (values.find((item) => item.form_question_id === 20)?.value.caseType as string) ===
              CaseType.clinical_enablement
          ) {
            dispatch(setStaffIntakeInProgress(true));
          }
        }

        // Deferred: `setHasEditedSinceSave(false)` above only clears the "unsaved
        // changes" navigation blocker once React re-renders and this component's
        // own dirty-propagation effect and the parent's `useBlocker` effect both
        // run — neither of which has happened yet in this still-synchronous save
        // handler. `setMyProfileForm` a few lines up also re-triggers this form's
        // hydration effect on that same re-render, and that effect schedules its
        // own zero-delay re-clear of the dirty flag (see the comment there) to
        // undo any false-positive "user edited it" the hydration's own setValue
        // calls can trip. A plain `setTimeout(fn, 0)` here would be scheduled
        // *before* that re-clear even gets registered (it needs a render + effect
        // pass to run first) and so would consistently fire first, navigating
        // while the flag was still wrongly true. Giving this one a small positive
        // delay guarantees it always runs after that cleanup lands.
        // `replace`: once the profile is saved it is no longer part of the intake,
        // so Back from the next step returns to the case type selection rather
        // than to this profile page with the intake flag already cleared.
        setTimeout(() => {
          if (
            (values.find((item) => item.form_question_id === 20)?.value.caseType as string) ===
            CaseType.oral_health_coaching
          ) {
            // Coaching is booked with a care advisor, not a provider: same next step as
            // CreateConsultationFor takes when the patient's profile was already complete.
            roleNavigate('/select-care-advisor', {
              replace: true,
              state: {
                caseType: CaseType.oral_health_coaching,
                insuranceCarrierId: '',
                customInsuranceCarrier: '',
                userOrganization: currentOrganization.id,
                patientId: (updatedUser as UserProfile | undefined)?.id ?? thisUser?.id,
              },
            });
          } else if (
            (values.find((item) => item.form_question_id === 20)?.value.caseType as string) ===
              'video_call_scheduled' ||
            (values.find((item) => item.form_question_id === 20)?.value.caseType as string) ===
              CaseType.phone_call_scheduled
          ) {
            roleNavigate('/select-provider', {
              replace: true,
              state: {
                caseType: values.find((item) => item.form_question_id === 20)?.value.caseType as string,
                insuranceCarrierId: '',
                customInsuranceCarrier: '',
                userOrganization: currentOrganization.id,
                patientId: (updatedUser as UserProfile | undefined)?.id ?? thisUser?.id,
              },
            });
          } else if (
            (values.find((item) => item.form_question_id === 20)?.value.caseType as string) ===
              CaseType.second_opinion ||
            (values.find((item) => item.form_question_id === 20)?.value.caseType as string) === CaseType.one_report
          ) {
            // Same next step CreateConsultationFor takes for these case types when the
            // profile was already complete; the catch-all /describe-pain-level below
            // skipped the medical-history and pharmacy steps.
            roleNavigate(userInfo.role.name === UserRoleName.Admin ? '/select-pharmacy' : '/clinical-data', {
              replace: true,
              state: {
                caseType: values.find((item) => item.form_question_id === 20)?.value.caseType as string,
                patientState:
                  (updatedUser as UserProfile | undefined)?.address?.state ?? thisUser?.address?.state ?? '',
                userOrganization: currentOrganization.id,
                patientId: (updatedUser as UserProfile | undefined)?.id ?? thisUser?.id,
              },
            });
          } else if (
            (values.find((item) => item.form_question_id === 20)?.value.caseType as string) ===
            CaseType.care_coordination
          ) {
            // Same gate as the patient self-flow in
            // Profile/EditProfile.tsx: CC must skip the medical /
            // dental clinical-data and pain-level questionnaires
            // entirely, even for a brand-new patient. Without this
            // explicit branch, CC + paid (or CC + amount-zero with
            // payment options / insurance to collect) fell into the
            // catch-all /describe-pain-level below.
            if (!needsPayment(currentOrganizationPrices)) {
              roleNavigate('/select-patient', {
                replace: true,
                state: { caseType: CaseType.care_coordination },
              });
            } else {
              roleNavigate('/payment-information', {
                replace: true,
                state: { caseType: CaseType.care_coordination },
              });
            }
          } else if (
            (values.find((item) => item.form_question_id === 20)?.value.caseType as string) ===
            CaseType.clinical_enablement
          ) {
            // Resume where CreateConsultationFor sends this case type when the
            // profile was already complete: photos come first, then the
            // medical-history steps. The catch-all /describe-pain-level below
            // skipped both, so a brand-new patient's case had no photos.
            roleNavigate('/upload-image', {
              replace: true,
              state: {
                caseType: CaseType.clinical_enablement,
                patientState:
                  (updatedUser as UserProfile | undefined)?.address?.state ?? thisUser?.address?.state ?? '',
                userOrganization: currentOrganization.id,
                patientId: (updatedUser as UserProfile | undefined)?.id ?? thisUser?.id,
              },
            });
          } else {
            roleNavigate('/describe-pain-level', {
              replace: true,
              state: {
                caseType: values.find((item) => item.form_question_id === 20)?.value.caseType as string,
                patientState:
                  (updatedUser as UserProfile | undefined)?.address?.state ?? thisUser?.address?.state ?? '',
                userOrganization: currentOrganization.id,
                patientId: (updatedUser as UserProfile | undefined)?.id ?? thisUser?.id,
              },
            });
          }
        }, 50);
      }
    } catch (error: unknown) {
      displayErrorDetails(error);
    } finally {
      setIsSavingProfile(false);
    }
  };

  const updateCurrentAddress = (standardizedAddress: any, postalAddress: any, addressComponents: any): void => {
    const streetNumber = addressComponents.find(
      (addressComponent: any) => addressComponent.componentType === 'street_number',
    );
    const address1 = addressComponents.find((addressComponent: any) => addressComponent.componentType === 'route');
    const state = addressComponents.find(
      (addressComponent: any) => addressComponent.componentType === 'administrative_area_level_1',
    );

    if (postalAddress) {
      setValue('city', postalAddress.locality);
      setValue('zip_code', postalAddress.postalCode);
    }

    if (streetNumber || address1) {
      setValue('address1', `${streetNumber?.componentName?.text || ''} ${address1?.componentName?.text || ''}`.trim());
    }

    if (state) {
      setValue('state', state.componentName?.text || '');
    } else if (standardizedAddress?.state) {
      setValue('state', standardizedAddress.state);
    }
  };

  const onSubmitProfile = async (profileData: MyProfileSubmit): Promise<void> => {
    if (
      divisionRequired &&
      (profileData.clientTag || []).length > 0 &&
      getValues('organizations')?.some((org) => org.id === 'dentistry-one') &&
      (profileData.clientDivision || []).length === 0
    ) {
      toast.error('Select a division.', { className: 'fs-unmask' });
      return;
    }
    if (isOptionalAddressLeftBlank(profileData)) {
      await callSaveProfile(profileData);
      return;
    }
    await validateAddress(
      profileData,
      getValues as UseFormGetValues<UnifiedProfileSubmit>,
      validationResponseId,
      callSaveProfile,
      setValidationResponseId,
      setShowValidationAddressModal,
      onCloseConfirmationModal,
      updateCurrentAddress,
    );
  };
  const setTextValue = (e: React.ChangeEvent<HTMLInputElement>, name: string): void => {
    const { value } = e.target;
    setValue(name as keyof MyProfileSubmit, value, { shouldValidate: true });
    setSelection([e.target.selectionStart, e.target.selectionEnd]);
  };

  // Field names in the same top-to-bottom, left-to-right order they appear in the
  // form below, so the toast and the focused field always agree on which invalid
  // field is "first" — the errors object from the Yup resolver is keyed in schema
  // declaration order, not layout order, so picking Object.values(...)[0] directly
  // could surface (and focus) a field further down the page than one above it.
  const FORM_FIELD_VISUAL_ORDER = [
    'first_name',
    'middle_name',
    'last_name',
    'preferred_name',
    'date_of_birth',
    'email',
    'phone_number',
    'gender',
    'gender_identity',
    'pronouns',
    'language',
    'address1',
    'address2',
    'city',
    'state',
    'zip_code',
  ] as const;

  const onInvalid = (errorsList: any): void => {
    const firstErrorField = FORM_FIELD_VISUAL_ORDER.find((field) => errorsList[field]);
    const error = firstErrorField ? errorsList[firstErrorField] : (Object.values(errorsList)[0] as any);
    if (error) {
      toast.error(error.message as string, { className: 'fs-unmask' });
    }
    if (firstErrorField) {
      setFocus(firstErrorField as keyof MyProfileSubmit);
    }
  };

  const onCancelEditProfile = (): void => {
    // `setIsEditProfile(false)` unmounts this component in the same render (switching to
    // ReadOnlyProfile), so the effect that normally propagates `hasEditedSinceSave` to the
    // parent never gets to run with the reset value. Call `setIsDirty` directly instead of
    // relying on it, or the unsaved-changes prompt would keep blocking navigation even after
    // the user discards.
    hasUserEditedFormRef.current = false;
    setHasEditedSinceSave(false);
    setIsDirty?.(false);
    setImage(currentAvatarURL);
    setIsEditProfile(false);
    if (isFromSelectPatient) {
      dispatch(setIsFromSelectPatient(false));
      dispatch(setDependentId(null));
      if (
        isAdminRole ||
        userInfo.role.name === UserRoleName.Collector ||
        userInfo.role.name === UserRoleName.CareAdvisor
      ) {
        const roleName = selectedPatient.role?.name ?? UserRoleName.Patient;
        navigate(
          `${getStaffReviewProfileBasePath(userInfo.role.name)}/${roleName}/${
            selectedPatient.id
          }/create-consultation-for`,
          { state: { caseType: values.find((item) => item.form_question_id === 20)?.value.caseType as string } },
        );
      } else {
        roleNavigate('/select-patient', {
          state: { caseType: values.find((item) => item.form_question_id === 20)?.value.caseType as string },
        });
      }
    }
  };

  useEffect(() => {
    if (hasUserEditedFormRef.current) return;

    isHydratingFormRef.current = true;
    try {
      if (Object.keys(myProfileForm).length > 0) {
        Object.keys(myProfileForm).forEach((k: unknown) => {
          setValue(k as keyof MyProfileSubmit, myProfileForm[k as keyof MyProfileSubmit]);
        });
      }
      setKey((currentKey) => currentKey + 1);
      if (myProfileForm.clientTag && myProfileForm.clientTag?.length > 0) {
        setValue('clientTag', myProfileForm.clientTag);
      }
    } finally {
      isHydratingFormRef.current = false;
      // Belt-and-suspenders: if the watch subscription above (Line ~246) processes
      // one of this effect's own setValue calls after isHydratingFormRef has already
      // flipped back to false — which happens whenever react-hook-form defers that
      // notification by even a microtask — it wrongly marks the just-saved, freshly
      // re-hydrated form as user-edited again, and the "unsaved changes" prompt pops
      // right back up on the very next navigation. A macrotask-deferred re-clear runs
      // after any such pending microtask, so it always wins the race.
      setTimeout(() => {
        hasUserEditedFormRef.current = false;
        setHasEditedSinceSave(false);
      }, 0);
    }
  }, [myProfileForm, setValue]);
  useEffect(() => {
    // Fires on the initial avatar fetch too (image goes from undefined to a URL on mount),
    // which isn't a user edit — guard with isHydratingFormRef so the watch subscription
    // above doesn't mark the form dirty and trigger a false "unsaved changes" prompt.
    if (!image) return;
    isHydratingFormRef.current = true;
    try {
      triggerProfileAvatar(image);
    } finally {
      isHydratingFormRef.current = false;
    }
  }, [image, triggerProfileAvatar]);

  return (
    <div className={styles.editProfileContainer}>
      <div className={styles.titleContainer}>
        <h2 className={`fs-unmask ${styles.title}`}>Basic information</h2>
      </div>
      <div className={styles.editContainer}>
        {!reviewProfile && (
          <ProfileImage
            reviewProfile={reviewProfile}
            id={id}
            setCurrentAvatarURL={setCurrentAvatarURL}
            setAvatarFile={setAvatarFile}
            setAvatarPayload={setAvatarPayload}
            setAvatarAction={setAvatarAction}
            triggerProfileAvatar={triggerProfileAvatar}
            setImage={setImage}
            image={image}
            errors={errors}
            size="80px"
            thisUser={thisUser as UserProfile}
          />
        )}
        <form
          ref={formRef}
          className={styles.formContainer}
          onSubmit={handleSubmit(onSubmitProfile, onInvalid)}
          key={key}
        >
          {/* Disables every field while a save is in flight: an edit made mid-save would
              otherwise get folded into the post-save snapshot and marked "saved" even though
              it was never actually sent in that request. */}
          <fieldset disabled={isSavingProfile} style={{ border: 'none', margin: 0, padding: 0, minWidth: 0 }}>
            {/* Name row */}
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 3 }}>
              <TextField
                {...register('first_name')}
                label="First name"
                required
                errors={errors}
                value={getValues('first_name')}
                onChange={(e) => setTextValue(e, 'first_name')}
                name="first_name"
                wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
              />
              <TextField
                {...register('middle_name')}
                label="Middle name (optional)"
                errors={errors}
                value={getValues('middle_name')}
                onChange={(e) => setTextValue(e, 'middle_name')}
                name="middle_name"
                wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
              />
              <TextField
                {...register('last_name')}
                label="Last name"
                required
                errors={errors}
                value={getValues('last_name')}
                onChange={(e) => setTextValue(e, 'last_name')}
                name="last_name"
                wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
              />
            </Box>

            {/* Preferred name + DOB row */}
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 3 }}>
              <TextField
                {...register('preferred_name')}
                label="Preferred name (optional)"
                errors={errors}
                value={getValues('preferred_name')}
                onChange={(e) => setTextValue(e, 'preferred_name')}
                name="preferred_name"
                wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
              />
              <TextField
                {...register('date_of_birth')}
                label="Date of birth"
                required
                errors={errors}
                placeholder="MM / DD / YYYY"
                value={getValues('date_of_birth')}
                onChange={(e) => dateAutoSlashes(e, 'date_of_birth', setValue)}
                name="date_of_birth"
                maxLength={10}
                wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
              />
            </Box>

            {/* Email + Phone row */}
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 3 }}>
              {reviewProfile && isAdminRole && (
                <TextField
                  {...register('email')}
                  label="Email address"
                  required={!isEssentialProfileIntake}
                  errors={errors}
                  value={getValues('email')}
                  onChange={(e) => setTextValue(e, 'email')}
                  name="email"
                  wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
                />
              )}
              <Box className={addNewUserStyles.inputWrap}>
                <PhoneInput
                  {...register('phone_number')}
                  value={getValues('phone_number') as E164Number}
                  name="phone_number"
                  required={!isEssentialProfileIntake}
                  errors={errors}
                  onChange={(v) => setValue('phone_number', v ?? '', { shouldValidate: true })}
                  label="Phone number"
                  wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
                />
              </Box>
            </Box>

            {/* Gender / identity / pronouns row */}
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 3 }}>
              <Box className={addNewUserStyles.inputWrap}>
                <MUISelectInput
                  {...register('gender')}
                  label="Gender assigned at birth"
                  required={!isEssentialProfileIntake && (!isAdminRole || isFromSelectPatient)}
                  errors={errors}
                  value={getValues('gender') || ''}
                  onChange={(v: string) => setValue('gender', v, { shouldValidate: true })}
                  name="gender"
                  options={genderOptions}
                />
              </Box>
              <Box className={addNewUserStyles.inputWrap}>
                <MUISelectInput
                  {...register('gender_identity')}
                  label={`Gender identity${
                    (isAdminRole && !isFromSelectPatient) || isEssentialProfileIntake ? '' : ' *'
                  }`}
                  errors={errors}
                  value={getValues('gender_identity') || ''}
                  onChange={(v: string) => setValue('gender_identity', v, { shouldValidate: true })}
                  name="gender_identity"
                  options={genderIdentity}
                />
              </Box>
              <Box className={addNewUserStyles.inputWrap}>
                <MUISelectInput
                  {...register('pronouns')}
                  label="Preferred pronouns (optional)"
                  errors={errors}
                  value={getValues('pronouns') || ''}
                  onChange={(v: string) => setValue('pronouns', v, { shouldValidate: true })}
                  name="pronouns"
                  options={pronounsOptions}
                />
              </Box>
            </Box>

            {/* Languages row */}
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 3 }}>
              <MultiSelectInputMUI
                {...register('language')}
                label="Languages"
                required={!isEssentialProfileIntake}
                errors={errors}
                name="language"
                styledTag
                value={((getValues('language') as OptionLanguage[]) || []).map((l) => String(l.id))}
                onChange={(ids: string[]) =>
                  setValue(
                    'language',
                    languageOptions.filter((l) => ids.includes(String(l.id))) as MultiValue<OptionLanguage>,
                    { shouldValidate: true },
                  )
                }
                options={languageOptions}
                wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
              />
            </Box>

            {/* Address section */}
            <div className={styles.separator} />
            <div className={styles.row}>
              <AddressSection
                register={register}
                errors={errors}
                getValues={getValues}
                setTextValue={setTextValue}
                setValue={setValue}
                showValidationAddressModal={showValidationAddressModal}
                required={!isEssentialProfileIntake}
              />
            </div>
            <div className={styles.separator} />

            {/* Client tags (reviewProfile only) */}
            {reviewProfile && (
              <Box sx={{ mt: 3 }}>
                {isAdminRole && getValues('organizations')?.some((org) => org.id === 'dentistry-one') && (
                  <>
                    <Divider sx={{ my: 3, mx: 0 }} />

                    {/* Client tags */}
                    <Typography variant="subtitle1" fontWeight={600} sx={{ fontSize: '20px', mb: 2 }}>
                      Client tags
                    </Typography>
                    <p className={styles.clientTagsDescription}>
                      Select the client tag for this patient&apos;s Dentistry.One services.
                    </p>
                    <Box sx={{ mb: 2 }}>
                      {clientTagsLocked ? (
                        <MultiSelectInputMUI
                          name="locked_client_tags"
                          label="Client tag(s)"
                          withId
                          disabled
                          options={lockedClientTagOptions}
                          value={lockedClientTagOptions.map((option) => option.id)}
                        />
                      ) : (
                        <MUISelectInput
                          name="clientTag"
                          label="Client tag"
                          required
                          value={watch('clientTag')?.[0]?.value ?? ''}
                          options={clientTagOptions}
                          errors={errors}
                          onChange={(value: string) => {
                            const selected = clientTagOptions.find((tag) => tag.value === value);
                            setValue('clientTag', selected ? [selected] : [], { shouldValidate: true });
                            setValue('clientDivision', [], { shouldValidate: true });
                          }}
                        />
                      )}
                    </Box>

                    {(watch('clientTag') || []).length > 0 &&
                      divisionOptions.length > 0 &&
                      !patientDivisionOutOfScope && (
                        <Box sx={{ mb: 2 }}>
                          <MUISelectInput
                            name="clientDivision"
                            label="Division"
                            required={divisionRequired}
                            value={watch('clientDivision')?.[0]?.value ?? ''}
                            options={divisionOptions}
                            onChange={(value: string) => {
                              const selected = divisionOptions.find((division) => division.value === value);
                              setValue('clientDivision', selected ? [selected] : [], { shouldValidate: true });
                            }}
                          />
                        </Box>
                      )}
                  </>
                )}

                {/* User IDs: staff-only, never shown on a patient's own My Profile
                    (this component only renders with reviewProfile=true). */}
                {(userInfo.role.name === UserRoleName.SuperAdmin ||
                  userInfo.role.name === UserRoleName.Admin ||
                  userInfo.role.name === UserRoleName.OrganizationAdmin ||
                  userInfo.role.name === UserRoleName.CareAdvisor ||
                  userInfo.role.name === UserRoleName.Collector) && (
                  <>
                    <Divider sx={{ my: 3, mx: 0 }} />
                    <Typography variant="subtitle1" fontWeight={600} sx={{ fontSize: '20px', mb: 2 }}>
                      User IDs
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
                      <TextField
                        name="external_id"
                        label="External User ID"
                        value={getValues('external_id') ?? ''}
                        onChange={(e) => setTextValue(e, 'external_id')}
                        maxLength={40}
                        wrapperClassName={`fs-exclude ${addNewUserStyles.inputWrap}`}
                      />
                      <TextField
                        name="internalUserId"
                        label="Internal User ID"
                        value={String(thisUser?.id ?? '')}
                        disabled
                        wrapperClassName={addNewUserStyles.inputWrap}
                      />
                    </Box>
                  </>
                )}
              </Box>
            )}
          </fieldset>

          {(() => {
            const isCollectorCc =
              (userInfo.role.name === UserRoleName.Collector || userInfo.role.name === UserRoleName.CareAdvisor) &&
              isFromSelectPatient;
            const isAdminReview = isAdminRole && Boolean(reviewProfile);

            if (isAdminReview) {
              return (
                <div className={addNewUserStyles.actions}>
                  <MuiButton
                    type="submit"
                    variant="contained"
                    disabled={
                      (isEqual(myProfileForm, getValues()) && isEqual(avatarAction, '')) ||
                      isSavingProfile ||
                      fetchLoading
                    }
                    className={addNewUserStyles.saveChangesButton}
                  >
                    {isSavingProfile ? 'Saving…' : 'Save changes'}
                  </MuiButton>
                </div>
              );
            }

            return (
              <div className={`${styles.actionBtnContainer} ${isCollectorCc ? styles.collectorCcActionRow : ''}`}>
                <Button
                  type="button"
                  className={`fs-unmask ${isCollectorCc ? styles.collectorCcBackLink : styles.cancel}`}
                  onClick={onCancelEditProfile}
                >
                  {isCollectorCc ? (
                    <>
                      <MdKeyboardArrowLeft /> Back
                    </>
                  ) : (
                    'Cancel'
                  )}
                </Button>
                <Button
                  type="submit"
                  className={`fs-unmask ${isCollectorCc ? styles.collectorCcNextBtn : styles.submit}`}
                  disabled={
                    (isEqual(myProfileForm, getValues()) && isEqual(avatarAction, '')) ||
                    isSavingProfile ||
                    fetchLoading
                  }
                >
                  {isCollectorCc
                    ? 'Next'
                    : isFromSelectPatient && !isEditInsuranceFlag
                    ? 'Continue'
                    : isFromSelectPatient && isEditInsuranceFlag && !isEqual(myProfileForm, getValues())
                    ? (values.find((item) => item.form_question_id === 20)?.value.caseType as string) ===
                        CaseType.care_coordination && isFree(currentOrganizationPrices)
                      ? 'Save'
                      : 'Continue'
                    : 'Save'}
                </Button>
              </div>
            );
          })()}
        </form>
      </div>
    </div>
  );
};

export default EditProfile;
